module.exports = "<div ng-transclude ng-click=\"ctrl.openOrder()\">\n\n</div>";